<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="3" />
    <div class="mb-3">
      <div class="row">
        <div class="col-11">
          <div class="breadcrumb-container">
            <router-link to="/plantilla">Plantillas</router-link>
            > {{ datoPlantilla.nombre }}
          </div>
        </div>
        <div class="col-1">
          <span class="material-symbols-outlined" style="font-size:32px;color:blue; cursor: pointer;"
            @click="showModalHelp = true">help
          </span>
        </div>
      </div>
    </div>
    <hr>
<!-- Master -->
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-2">
                  <label for="idPlantilla" class="form-label">Id</label>
                  <input type="text" class="form-control" id="idPlantilla" name="idPlantilla" v-model="datoPlantilla.idPlantilla" disabled>
                </div>
                <div class="col-10">
                  <label for="nombre" class="form-label">Nombre</label>
                  <input type="text" class="form-control" id="nombre" name="nombre" v-model="datoPlantilla.nombre" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
        <button type="submit" class="btn btn-light" @click.prevent="guardarPlantilla" v-if="btnCrear" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditPlantilla" v-if="btnEditar" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>

<!-- Details -->
    <hr>
      <div class="mb-3">
        <table class="tablaBusqueda">
          <tr>
            <td><label for="nombre" class="form-label">Nombre</label></td>
            <td><input type="text" class="form-control" id="nombreBusqueda" name="nombreBusqueda" v-model="nombreBusqueda" style="width: 500px; text-transform:uppercase;" required></td>
            <td class="centro">
              <button type="submit" class="btn btn-light" @click.prevent="getDataPagina(1)" title="Buscar registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">search</i> Buscar
              </button>
            </td>
            <td class="centro">
              <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Todos los registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">auto_awesome_motion</i>
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ventanaModal" @click="abrirModalCrear" title="Nuevo registro">
                <i class="material-icons" style="font-size:24px;color:green; cursor: pointer;">add_box</i>
              </button>
            </td>
          </tr>
        </table>
      </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
<!--           <th scope="col">IdPlantillaDet</th>
          <th scope="col">IdPlantilla</th>
          <th scope="col">IdElemento</th>
          <th scope="col">PlantillaNombre</th>
 -->          <th scope="col">Código</th>
          <th scope="col">Nombre TPSNS/Medicamento/Insumo</th>
          <th scope="col">Estado</th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="plantilladet in datosPaginados" :key="plantilladet.idPlantillaDet">
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirModalEditar(plantilladet.idPlantillaDet)" title="Editar">edit_square</i></td>
<!--           <td>{{plantilladet.idPlantillaDet}}</td>
          <td>{{plantilladet.idPlantilla}}</td>
          <td>{{plantilladet.idElemento}}</td>
          <td>{{plantilladet.plantillaNombre}}</td> -->
          <td>{{plantilladet.elementoCodigo}}</td>
          <td>{{plantilladet.elementoNombre}}</td>
          <td>{{plantilladet.estado}}</td>
          <td><i class="material-icons" style="font-size:16px;color:red; cursor: pointer;" @click="deletePlantilla(plantilladet.idPlantillaDet)" title="Borrar">delete</i></td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()"><a class="page-link" href="#">Anterior</a></li>
        <li id="lugar" v-for="pagina in totalPaginas()" v-bind:key="pagina" v-on:click = "getDataPagina(pagina)" class="page-item" v-bind:class="isActive(pagina)"><a class="page-link" href="#">{{pagina}}</a></li>
        <li class="page-item" v-on:click="getNextPage()"><a class="page-link" href="#">Siguiente</a></li>
      </ul>
    </nav>
<!-- Modal -->
<div class="modal fade" id="ventanaModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" v-if="modalWindow">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
        </button>
      </div>
      <form>
        <div class="modal-body">
<!--             <div class="mb-3" v-if="btnEditar_det">
              <div class="row">
                <div class="col-2">
                  <label for="idPlantillaDet" class="form-label">IdPlantillaDet</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idPlantillaDet" name="idPlantillaDet" v-model="datoPlantillaDet.idPlantillaDet" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="idPlantilla" class="form-label">IdPlantilla</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idPlantilla" name="idPlantilla" v-model="datoPlantillaDet.idPlantilla" style='text-transform:uppercase' required>
                </div>
              </div>
            </div> -->

            <!-- Campo Elemento con búsqueda dinámica -->
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="idElemento" class="form-label">Elemento</label>
                </div>
                <div class="col-10">
                  <div class="input-group">
                    <input
                      type="text"
                      class="form-control"
                      v-model="searchTextElemento"
                      @input="filterElementos"
                      @focus="showDropdownElemento = true"
                      @blur="hideDropdown('Elemento')"
                      placeholder="Buscar elemento..."
                    />
                    <ul
                      class="dropdown-menu shadow"
                      :class="{ show: showDropdownElemento }"
                      style="max-height: 250px; overflow-y: auto; width: 100%;"
                    >
                      <li v-for="elemento in filteredElementos" :key="elemento.idElemento">
                        <a class="dropdown-item" href="#" @mousedown.prevent="selectElemento(elemento)">
                          {{ elemento.codigo }} - {{ elemento.nombre }}
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

          </div>
      </form>
      <div class="modal-footer">
        <button type="submit" class="btn btn-light" @click.prevent="guardarPlantillaDet" v-if="btnCrear_det" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditPlantillaDet" v-if="btnEditar_det" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>
</div>
<!-- Details -->

    <Footer/>
  </div>
</template>
<script>
import Layout from '../../components/Layout.vue'
import Footer from '../../components/Footer.vue'
import { validarForm } from '../../modules/validacionesForms.js';
import api from "@/services/api";
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal from  'sweetalert'
export default {
  components : {
    Layout, Footer
  },
  data () {
    return {
// Variables master
      plantillas : [],
      datoPlantilla : {},
      nombreBusqueda: '',
      titulo: '',
      btnCrear: false,
      btnEditar: false,
      p_idPlantilla: '',
// Variables master
      showModalHelp: false,
      searchTextElemento: '',
      filteredElementos: [],
      showDropdownElemento: false,
// Variables details
      plantilladets : [],
      datoPlantillaDet : {},
      nombreBusqueda_det: '',
      titulo_det: '',
      btnCrear_det: false,
      btnEditar_det: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      elementos : [],
      modalWindow: true
// Variables details
    }
  },
  mounted () {
    this.p_idPlantilla = this.$route.params.p_idplantilla
    this.abrirEditar(this.p_idPlantilla)
    this.getDataPaginaTodos(1)
    this.fetchElementos()
    this.$refs.layoutRef.toggleProcesos()
    this.$refs.layoutRef.toggleReportes()
    this.$refs.layoutRef.toggleParametros()
    this.$refs.layoutRef.toggleAyuda()
  },
  methods : {
// Procedimientos master
    validarForm(){
      const requiredFields = [
        'nombre'
      ];
      const requiredFieldsText = [
        'nombre'
      ];
      return validarForm(this.datoPlantilla, requiredFields, requiredFieldsText);
    },
    async guardarPlantilla(){
      if(this.validarForm() === 1){
        try {
          await api.post('/plantillas', this.datoPlantilla)
          swal("Correcto!", "Plantilla creada exitosamente!", "success");
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditPlantilla(){
      if(this.validarForm() === 1){
        try {
          await api.post('/plantillas', this.datoPlantilla)
          swal("Correcto!", "Plantilla creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirCrear(){
      this.modalWindow = true
      this.datoPlantilla={}
      this.titulo   = 'Crear '
      this.btnCrear = true
      this.btnEditar= false
    },
    abrirEditar(idPlantilla){
      this.modalWindow = true
      if(idPlantilla != null){    
           api.get('/vwplantillas/'+idPlantilla).then(resp=>{
          this.datoPlantilla = resp.data;
           });
      }
      this.titulo   = 'Editar '
      this.btnCrear = false
      this.btnEditar= true
    },
    cerrarPlantilla(){
      this.$router.push('/Plantilla')
    },
// Procedimientos master
// Procedimientos detalle
    totalPaginas(){
      return Math.ceil(this.plantilladets.length / this.elementosPorPagina)
    },
    getDataPagina(noPagina){
      if(this.nombreBusqueda != '') {
        api.get('/vwplantilladets/idplantilla/'+this.p_idPlantilla+'?nombre='+this.nombreBusqueda).then(response=>{
          this.plantilladets=response.data.reverse();  
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
          let fin = (noPagina * this.elementosPorPagina);
          this.datosPaginados = this.plantilladets.slice(ini,fin);
        });
      }
    },
    getDataPaginaTodos(noPagina){
      api.get('/vwplantilladets/idplantilla/'+this.p_idPlantilla).then(response=>{
      this.plantilladets=response.data.reverse();  
      this.paginaActual = noPagina;
      this.datosPaginados = [];
      let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
      let fin = (noPagina * this.elementosPorPagina);
      this.datosPaginados = this.plantilladets.slice(ini,fin);
       });
    },
    getPreviousPage(){
      if(this.paginaActual > 1){
        this.paginaActual--;
      }
      this.getDataPagina(this.paginaActual);
    },
    getNextPage(){
      if(this.paginaActual < this.totalPaginas()){
        this.paginaActual++;
      }
      this.getDataPagina(this.paginaActual);
    },
    isActive(noPagina){
      return noPagina == this.paginaActual ? 'active' : ''
    },
    validarFormDet(){
      const requiredFields = [
        'nombre'
      ];
      const requiredFieldsText = [
        'nombre'
      ];
      return validarForm(this.datoPlantilla, requiredFields, requiredFieldsText);
    },
    async guardarPlantillaDet(){
      if(this.validarForm() === 1){
        try {
          this.datoPlantillaDet.idPlantilla = this.datoPlantilla.idPlantilla;
          await api.post('/plantilladets', this.datoPlantillaDet)
          $('#ventanaModal').modal('hide');
          swal("Correcto!", "PlantillaDet creada exitosamente!", "success");
          this.getDataPagina(this.paginaActual);
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditPlantillaDet(){
      if(this.validarForm() === 1){
        try {
          await api.post('/plantilladets', this.datoPlantillaDet)
          $('#ventanaModal').modal('hide');
          this.getDataPagina(this.paginaActual);
          swal("Correcto!", "PlantillaDet creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirModalCrear(){
      this.modalWindow = true
      this.datoPlantillaDet={}
      this.titulo   = 'Crear '
      this.btnCrear_det  = true
      this.btnEditar_det = false
      this.searchTextElemento = '';
      this.searchTextExamen = '';
    },
    abrirModalEditar(idPlantillaDet){
      this.modalWindow = true
      if(idPlantillaDet != null){    
        api.get('/vwplantilladets/'+idPlantillaDet).then(resp=>{
          this.datoPlantillaDet = resp.data;
          this.searchTextElemento = this.datoPlantillaDet.elementoCodigo + " - " + this.datoPlantillaDet.elementoNombre;
          this.searchTextExamen = this.datoPlantillaDet.examenNombre;
        });
      }
      $('#ventanaModal').modal('show');
      this.titulo   = 'Editar '
      this.btnCrear_det  = false
      this.btnEditar_det = true
    },
    abrirEditarDet(idPlantillaDet){
      this.modalWindow = true
      if(idPlantillaDet != null){
        this.$router.push('/plantilladetmd/'+idPlantillaDet)
      }
    },
    async deletePlantillaDet (idPlantillaDet) {
      try{
        await api.delete('/plantilladets/'+idPlantillaDet)
          this.getDataPagina(this.paginaActual);
      }catch(error){
        alert('No se pudo eliminar')
      }
    },
// Procedimientos detalle
    fetchElementos() {
      fetch('http://localhost:8080/api/v1/vwelementos')
        .then(response => response.json())
        .then(data => {
          this.elementos = data;
        })
        .catch(error => {
          console.error('Error fetching elementos:', error);
        });
    },

    // Ocultar dropdown al perder el foco
    hideDropdown(type) {
      setTimeout(() => {
        if (type === 'Elemento') this.showDropdownElemento = false;
      }, 200); // Agrega un retraso para permitir el evento click
    },

    // Filtrar elementos
    filterElementos() {
      this.filteredElementos = this.elementos.filter((elemento) =>
        elemento.nombre.toLowerCase().includes(this.searchTextElemento.toLowerCase())
      );
    },

    // Seleccionar un elemento del dropdown
    selectElemento(elemento) {
      this.datoPlantillaDet.idElemento = elemento.idElemento;
      this.searchTextElemento = elemento.nombre;
      this.showDropdownElemento = false; // Ocultar el dropdown
    },
      
  },
}
</script>
